import { render, staticRenderFns } from "./EdicionesBody.vue?vue&type=template&id=42f765a8"
import script from "./EdicionesBody.vue?vue&type=script&lang=js"
export * from "./EdicionesBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports